import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const eventMasterService = createApi({
    reducerPath: 'eventMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['EventMaster'],
    endpoints: (builder) => ({
        getAllEventMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventMasterController.getAllEventMasterWithPagination}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getEventMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventMasterController.getEventMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveEventMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventMasterController.saveEventMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateEventMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventMasterController.updateEventMaster}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteEventMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventMasterController.deleteEventMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllEventMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventMasterController.findAllEventMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveEventMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.eventMasterController.bulkSaveEventMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllEventMasterMutation,
    useGetEventMasterByIdMutation,
    useSaveEventMasterMutation,
    useUpdateEventMasterMutation,
    useDeleteEventMasterMutation,
    useFindAllEventMasterMutation,
    useBulkSaveEventMasterMutation
} = eventMasterService;
